import React, { FC } from "react";
import { Card, CardContent, TextField } from "@mui/material";
import { FlexiableBooking, HelpCircle } from "@/components/icons";
import RightSideArrow from "@/components/icons/RightSideArrow";
type IconKey = "FlexiableBooking" | "HelpCircle";

interface DealHubSectionProps {
  data: {
    leftCard: {
      heading: string;
      description: string;
      textFieldPlaceholder: string;
      buttonText: string;
    };
    cards: {
      title: string;
      description: string;
      icon: IconKey;
    }[];
  };
}

const DealHubSection: FC<DealHubSectionProps> = ({ data }) => {
  const iconMap = {
    FlexiableBooking: <FlexiableBooking />,
    HelpCircle: <HelpCircle />,
  };

  return (
    <div className="flex c-lg:flex-row flex-col w-full max-w-[1328px] px-4 items-center justify-between gap-[30px] mx-auto">
      <Card className="w-full max-w-[694px] c-lg:h-[250px] h-fit !shadow-none border border-[#D8DCDE] !rounded-xl">
        <CardContent className="flex flex-col justify-center h-full gap-4 p-5 max-c-lg:text-center">
          <h2 className="c-lg:text-[28px] text-xl  font-medium text-primary">
            {data.leftCard.heading}
          </h2>
          <p className="text-base leading-8 text-primary ">
            {data.leftCard.description}
          </p>
          <div className="flex c-lg:flex-row flex-col items-center justify-between gap-4">
            <TextField
              variant="outlined"
              placeholder={data.leftCard.textFieldPlaceholder}
              className="w-full max-w-[434px] bg-white !rounded-xl"
              size="small"
            />
            <button className="bg-secondary text-primary h-12 px-6 rounded-[48px] normal-case text-sm font-medium hover:bg-secondary">
              {data.leftCard.buttonText}
            </button>
          </div>
        </CardContent>
      </Card>

      <div className="flex flex-col w-full max-w-[558px] gap-[30px]">
        {data.cards.map((card, index) => (
          <Card
            key={index}
            className="h-[110px] !shadow-none border border-[#D8DCDE] !rounded-xl !p-[15px] flex items-center"
          >
            <CardContent className="flex items-center gap-4 !px-0 !py-[5px] w-full">
              <div className="flex items-center justify-center w-20 h-20 bg-[#d4af3712] !rounded-md">
                {iconMap[card.icon]}
              </div>

              <div className="flex items-center justify-between w-full text-secondary py-5">
                <div className="flex flex-col justify-around h-[84px]">
                  <h3 className="c-lg:text-[22px] text-lg leading-8 font-medium text-primary">
                    {card.title}
                  </h3>
                  <p className="text-xs leading-5 text-primary  max-w-[386px]">
                    {card.description}
                  </p>
                </div>
                <RightSideArrow className="!w-6 !h-6 rtl:rotate-180 max-c-lg:hidden" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default DealHubSection;
